const { SITE_PAGES } = require('Config');
const { NOTE_UPDATE_ACTIONS } = require('Pages/Requests/Enum');
const { formatDateTime } = require('Util/dateUtil');
const { getUserNameFromId } = require('Data/context/Users');

module.exports.getRequestMessagesUpdatedHTML = (
  requestId,
  updateType,
  note,
) => {
  return `<!DOCTYPE html>
<html lang="en">
  <body
    style="
      font-family: arial, sans-serif;
      font-weight: 400;
      margin: 0;
      background-color: #f0f0f0;
      color: #1c2127;
    ">
    <div style="min-width: 340px; margin: 0 auto; background-color: #f0f0f0">
      <div
        style="
          margin: 0 auto;
          min-width: 340px;
          max-width: 600px;
          background-color: transparent;
          text-align: center;
        ">
        <!--HEADER BANNER-->
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 32px 0;
            color: white;
            background-color: #be0000;
            width: 100%;
          ">
          <img alt="BOS Logo" width="48" height="48" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IndoaXRlIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogICAgPHBhdGggZD0iTTEuOTUzIDQuNDgxbDcuNDEtNC4wMmMuMzk0LS4yMTUuODgtLjIxNSAxLjI3NSAwbDcuNDA5IDQuMDJMMTAgOS4yMiAxLjk1MyA0LjQ4em0tLjgxNy42OEw5LjUgMTAuMDg1djkuMjgxYTEuMzE2IDEuMzE2IDAgMDEtLjEzOC0uMDY0bC03LjcxNC00LjE4NkExLjIxMSAxLjIxMSAwIDAxMSAxNC4wNTd2LTguMzVjMC0uMTkzLjA0OC0uMzguMTM2LS41NDd6bTE3LjcyOCAwYy4wODguMTY2LjEzNi4zNTMuMTM2LjU0NnY4LjM1YzAgLjQzOC0uMjQ3Ljg0Mi0uNjQ4IDEuMDZsLTcuNzE0IDQuMTg2Yy0uMDQ1LjAyNC0uMDkxLjA0Ni0uMTM4LjA2NHYtOS4yODFsOC4zNjQtNC45MjZ6Ii8+Cjwvc3ZnPg==" >
          <span style="margin-left: 10px; font-size: 36px; font-weight: 500">
            HSC BOS
          </span>
        </div>

        <!--BODY-->
        <div style="background-color: #ffffff; height: 100%; width: 100%">
          <div
            style="
              word-wrap: break-word;
              font-size: 22px;
              font-weight: 700;
              padding: 24px;
            ">
            Request ${requestId} has been updated.
          </div>

          <div style="font-size: 18px; font-weight: 500; padding: 12px 0">
            A note has been ${
              updateType === NOTE_UPDATE_ACTIONS.DELETED
                ? 'deleted'
                : updateType === NOTE_UPDATE_ACTIONS.CREATED
                ? 'added'
                : 'updated'
            }:
          </div>

          <div
            style="
              margin: 0 32px;
              padding: 8px 16px;
              border: 1px solid rgba(17, 20, 24, 0.15);
              border-radius: 2px;
            ">
            <div style="padding: 6px; text-align: left">
              <span style="font-weight: 600; color: #be0000; margin-right: 6px">
                ${getUserNameFromId(note.user_id)}
              </span>
              <span
                style="font-style: italic; font-size: small; color: #8f99a8">
                ${note.createdAt ? formatDateTime(note.createdAt) : ''}
              </span>
            </div>
            <div style="border-bottom: 1px solid rgba(17, 20, 24, 0.15)"></div>
            <div style="padding: 6px; text-align: left">
              <div
                style="
                  font-size: 14px;
                  text-align: left;
                  word-wrap: break-word;
                  white-space: pre-line;
                  margin-top: -12px;
                ">
                ${note.content}
              </div>
            </div>
          </div>

          <div style="padding: 40px 0">
            <a
              href="${window.location.href.replace(window.location.hash, '')}${
    SITE_PAGES.ORDER_DETAIL.href
  }/${requestId}"
              target="_blank"
              style="
                box-sizing: border-box;
                display: inline-block;
                text-decoration: none;
                text-align: center;
                color: #ffffff;
                background-color: #be0000;
                max-width: 100%;
                font-size: 18px;
                padding: 20px 72px;
              ">
              Go to Request
            </a>
          </div>
        </div>

        <!--BODY FOOTER-->
        <div style="padding: 2px 0 0; background-color: transparent">
          <div style="margin: 0 auto; min-width: 340px; max-width: 600px">
            <div
              style="
                background-color: #ffffff;
                height: 100%;
                width: 100% !important;
                padding: 16px 0;
              ">
              <p style="text-align: center; font-size: 14px">
                If you have any questions, contact HSC Cores Admin Staff by
                replying to this email.
              </p>
            </div>
          </div>
        </div>

        <!--OUTER FOOTER-->
        <div style="margin: 0 auto; min-width: 340px; max-width: 600px">
          <div
            style="
              font-size: 14px;
              font-style: italic;
              color: #5f6b7c;
              text-align: center;
              padding: 16px 0;
              border-top: 1px solid #000000;
            ">
            <p>Sent by <a href="${window.location.href.replace(
              window.location.hash,
              '',
            )}">HSC BOS</a></p>
          </div>
        </div>
      </div>
    </div>
  </body>
</html>
`;
};

module.exports.getRequestRequiresApprovalHTML = (request, approver) => {
  return `<!DOCTYPE html>
<html lang="en">
  <body
    style="
      font-family: arial, sans-serif;
      font-weight: 400;
      margin: 0;
      background-color: #f0f0f0;
      color: #1c2127;
    ">
    <div style="min-width: 340px; margin: 0 auto; background-color: #f0f0f0">
      <div
        style="
          margin: 0 auto;
          min-width: 340px;
          max-width: 600px;
          background-color: transparent;
          text-align: center;
        ">
        <!--HEADER BANNER-->
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 32px 0;
            color: white;
            background-color: #be0000;
            width: 100%;
          ">
          <img alt="BOS Logo" width="48" height="48" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IndoaXRlIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogICAgPHBhdGggZD0iTTEuOTUzIDQuNDgxbDcuNDEtNC4wMmMuMzk0LS4yMTUuODgtLjIxNSAxLjI3NSAwbDcuNDA5IDQuMDJMMTAgOS4yMiAxLjk1MyA0LjQ4em0tLjgxNy42OEw5LjUgMTAuMDg1djkuMjgxYTEuMzE2IDEuMzE2IDAgMDEtLjEzOC0uMDY0bC03LjcxNC00LjE4NkExLjIxMSAxLjIxMSAwIDAxMSAxNC4wNTd2LTguMzVjMC0uMTkzLjA0OC0uMzguMTM2LS41NDd6bTE3LjcyOCAwYy4wODguMTY2LjEzNi4zNTMuMTM2LjU0NnY4LjM1YzAgLjQzOC0uMjQ3Ljg0Mi0uNjQ4IDEuMDZsLTcuNzE0IDQuMTg2Yy0uMDQ1LjAyNC0uMDkxLjA0Ni0uMTM4LjA2NHYtOS4yODFsOC4zNjQtNC45MjZ6Ii8+Cjwvc3ZnPg==" >
          <span style="margin-left: 10px; font-size: 36px; font-weight: 500">
            HSC BOS
          </span>
        </div>

        <!--BODY-->
        <div style="background-color: #ffffff; height: 100%; width: 100%">
          <div
            style="
              word-wrap: break-word;
              font-size: 22px;
              font-weight: 700;
              padding: 24px;
            ">
            A BOS Request (${
              request.id
            }) has been submitted and requires approval.
          </div>
          
          <div
            style="
              margin: 0 32px;
              padding: 8px 16px;
              border: 1px solid rgba(17, 20, 24, 0.15);
              border-radius: 2px;
            ">
            <div style="padding: 6px; text-align: left">
              <span style="font-weight: 600; color: #be0000; margin-right: 6px">
                Core Facility:
              </span>
              <span
                style="font-style: italic; color: #708e99">
                ${request.organization?.name}
              </span>
            </div>
            <div style="border-bottom: 1px solid rgba(17, 20, 24, 0.15)"></div>
            <div style="padding: 6px; text-align: left">
              <span style="font-weight: 600; color: #be0000; margin-right: 6px">
                Requester:
              </span>
              <span
                style="font-style: italic; color: #708e99">
                ${request.requester?.full_name}
              </span>
            </div>
            <div style="border-bottom: 1px solid rgba(17, 20, 24, 0.15)"></div>
            <div style="padding: 6px; text-align: left">
              <span style="font-weight: 600; color: #be0000; margin-right: 6px">
                Vendor:
              </span>
              <span
                style="font-style: italic; color: #708e99">
                ${request.vendor?.name}
              </span>
            </div>
            <div style="border-bottom: 1px solid rgba(17, 20, 24, 0.15)"></div>
           <div style="padding: 6px; text-align: left">
              <span style="font-weight: 600; color: #be0000; margin-right: 6px">
                Description:
              </span>
              <span
                style="font-style: italic; color: #708e99">
                ${request.notes}
              </span>
            </div>
          </div>

          <div style="padding: 40px 0; display: flex; justify-content: center;">
            <a
              href="${window.location.href.replace(window.location.hash, '')}${
    SITE_PAGES.ORDER_DETAIL.href
  }/${request.id}"
              target="_blank"
              style="
                box-sizing: border-box;
                display: inline-block;
                text-decoration: none;
                text-align: center;
                color: #ffffff;
                background-color: #be0000;
                max-width: 100%;
                font-size: 18px;
                padding: 20px 72px;
              ">
              View Request Details in BOS
            </a>
          </div>
        </div>

        <!--BODY FOOTER-->
        <div style="padding: 2px 0 0; background-color: transparent">
          <div style="margin: 0 auto; min-width: 340px; max-width: 600px">
            <div
              style="
                background-color: #ffffff;
                height: 100%;
                width: 100% !important;
                padding: 16px 0;
              ">
              <p style="text-align: center; font-size: 14px">
                If you have any questions, contact HSC Cores Admin Staff by
                replying to this email.
              </p>
            </div>
          </div>
        </div>

        <!--OUTER FOOTER-->
        <div style="margin: 0 auto; min-width: 340px; max-width: 600px">
          <div
            style="
              font-size: 14px;
              font-style: italic;
              color: #5f6b7c;
              text-align: center;
              padding: 16px 0;
              border-top: 1px solid #000000;
            ">
            <p>Sent by <a href="${window.location.href.replace(
              window.location.hash,
              '',
            )}">HSC BOS</a></p>
          </div>
        </div>
      </div>
    </div>
  </body>
</html>
`;
};
